import * as React from 'react';
import { PageProps } from 'gatsby';
import classNames from 'classnames';
import ContactForm from '../contact-form/contact-form';
import { useSiteMetadata } from '@/hooks/useSiteMetadata';

const Footer: React.FC<PageProps<{ is404?: boolean; version?: string }>> = ({
  data
}) => {
  const { envVarAtBuildTime: currentVersion } = useSiteMetadata();
  const currentYear = new Date().getFullYear();
  const footerLinks = [
    {
      url: 'https://www.fujitsu-general.com/global/terms/index.html',
      name: 'Terms of Service'
    },
    {
      url: 'https://www.fujitsu-general.com/global/privacy/index.html',
      name: 'Privacy Policy'
    }
  ];

  const linkClasses = (index: number): string =>
    classNames('block text-white py-[0.3125rem]', {
      "after:content-['|'] after:pl-[0.745rem] after:pr-[0.625rem]":
        index !== footerLinks.length - 1
    });

  return (
    <>
      {!data.is404 && <ContactForm />}
      <footer className="bg-black h-[7.75rem]">
        <div className="wrapper !px-[2.5rem] !py-[1.5rem] flex justify-between">
          <ul className="flex justify-between content-center">
            {footerLinks.map(({ url, name }, i) => (
              <li key={name}>
                <a
                  href={url}
                  className={linkClasses(i)}
                  target="_blank"
                  rel="noreferrer"
                >
                  {name}
                </a>
              </li>
            ))}
          </ul>
          <p className="text-white my-[0.625rem]">
            © {currentYear} FUJITSU GENERAL
            {currentVersion && (
              <span className="before:content-['|'] before:mx-2">
                v{currentVersion}
              </span>
            )}
          </p>
        </div>
      </footer>
    </>
  );
};

export default Footer;
